/*
  Dispatch promise: "Order now and it will be dispatched the next working day."

  The shop does not promise same-day dispatch (Mike, 30 Sep 2026), so the
  day is always the first working day AFTER today, whatever the time.

  Worked out in the browser, not in Liquid, because Shopify caches pages and
  Liquid's "now" is the time the page was cached, not the time it is read.
  All dates are UK dates: the shop does not dispatch at weekends or on the
  closed dates listed in theme settings.

  rcDispatchDay is pure and exported for Node, so the weekend, cut-off,
  bank-holiday and clock-change cases can be tested without a browser.
*/
(function (root) {
  // Parts of `date` as seen on a clock in London.
  function londonParts(date) {
    var f = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', hour12: false
    });
    var p = {};
    f.formatToParts(date).forEach(function (x) { p[x.type] = x.value; });
    return { y: +p.year, m: +p.month, d: +p.day, hour: +p.hour % 24 };
  }

  function iso(y, m, d) {
    return y + '-' + String(m).padStart(2, '0') + '-' + String(d).padStart(2, '0');
  }

  // Returns { date: 'YYYY-MM-DD', offset: days from today (London) }: the
  // first working day after today.
  function rcDispatchDay(now, closed) {
    var p = londonParts(now);
    var closedSet = {};
    (closed || []).forEach(function (c) { closedSet[c.trim()] = true; });
    // Calendar arithmetic on a UTC date so DST never shifts the day.
    var day = new Date(Date.UTC(p.y, p.m - 1, p.d));
    var offset = 0;
    var first = true;
    for (var guard = 0; guard < 30; guard++) {
      var dow = day.getUTCDay();
      var key = iso(day.getUTCFullYear(), day.getUTCMonth() + 1, day.getUTCDate());
      var working = dow !== 0 && dow !== 6 && !closedSet[key];
      if (working && !first) {
        return { date: key, offset: offset, weekday: dow };
      }
      first = false;
      day.setUTCDate(day.getUTCDate() + 1);
      offset++;
    }
    return null;
  }

  var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  function rcDispatchLabel(result) {
    if (!result) return '';
    if (result.offset === 0) return 'today';
    if (result.offset === 1) return 'tomorrow';
    if (result.offset < 7) return DAYS[result.weekday];
    var parts = result.date.split('-');
    return DAYS[result.weekday] + ' ' + (+parts[2]) + ' ' +
      ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][+parts[1] - 1];
  }

  function paint() {
    var cfgEl = document.getElementById('rc-dispatch-config');
    if (!cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var result = rcDispatchDay(new Date(), cfg.closed);
    if (!result) return;
    // The default lives here, not in Liquid: braces inside a Liquid string
    // break the output tag.
    var text = (cfg.message || 'Order now and it will be dispatched the next working day.')
      .replace('{time}', cfg.time || '5pm')
      .replace('{day}', rcDispatchLabel(result));
    document.querySelectorAll('[data-rc-dispatch]').forEach(function (el) {
      el.querySelector('[data-rc-dispatch-text]').textContent = text;
      el.hidden = false;
    });
  }

  root.rcDispatchDay = rcDispatchDay;
  root.rcDispatchLabel = rcDispatchLabel;

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paint);
    else paint();
  }
  if (typeof module !== 'undefined') module.exports = { rcDispatchDay: rcDispatchDay, rcDispatchLabel: rcDispatchLabel };
})(typeof window !== 'undefined' ? window : globalThis);
